import api from "./axiosConfig";

/**
 * Todos los reportes ahora aceptan filtros opcionales:
 * {
 *   start_date: "YYYY-MM-DD",
 *   end_date: "YYYY-MM-DD"
 * }
 */

// Sales summary
export const getSalesSummary = async (params = {}) => {
  const response = await api.get("/api/reports/sales-summary", {
    params,
  });
  return response.data;
};

// Sales by structure
export const getSalesByStructure = async (params = {}) => {
  const response = await api.get("/api/reports/sales-by-structure", {
    params,
  });
  return response.data;
};

// Sales by structure drilldown
export const getSalesByStructureDrilldown = async (params = {}) => {
  const response = await api.get(
    "/api/reports/sales-by-structure/drilldown",
    { params }
  );
  return response.data;
};

// Top clients
export const getTopClients = async (params = {}) => {
  const response = await api.get("/api/reports/top-clients", {
    params,
  });
  return response.data;
};

// Top products
export const getTopProducts = async (params = {}) => {
  const response = await api.get("/api/reports/top-products", {
    params,
  });
  return response.data;
};

// Sales over time (para el gráfico)
export const getSalesOverTime = async (params = {}) => {
  const response = await api.get("/api/reports/sales-over-time", {
    params,
  });
  return response.data;
};

// =====================================================================
// (2026-06-09) Reportes de COMPRAS (Panel de Control > Compras).
// Mismas formas que los de ventas, para reutilizar las tarjetas.
// =====================================================================
export const getPurchasesSummary = async (params = {}) => {
  const response = await api.get("/api/reports/purchases-summary", { params });
  return response.data;
};

export const getPurchasesOverTime = async (params = {}) => {
  const response = await api.get("/api/reports/purchases-over-time", { params });
  return response.data;
};

export const getTopSuppliers = async (params = {}) => {
  const response = await api.get("/api/reports/top-suppliers", { params });
  return response.data;
};

export const getTopPurchasedProducts = async (params = {}) => {
  const response = await api.get("/api/reports/top-purchased-products", { params });
  return response.data;
};
